import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { env, python } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentVariablesService {

  private readonly api_sql = `${python.url_var_env_crm}`;
  constructor(private http: HttpClient) { }

  loadConfig(): Observable<{success: boolean; message: string; data?: any; }> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http
      .post<{
        success: boolean;
        message: string;
        data: any;
      }>(`${this.api_sql}/variablesEntorno`, { headers })
      .pipe(
        map((response: any) => {
          if (response.success) {
            return {
              success: true,
              message: 'Variables de entorno encontrados',
              data: response.data
            };
          } else {
            return {
              success: false,
              message: 'No hay variables de entorno',
              data: []
            };
          }
        }),
        catchError((error) => {
          console.error('API error:', error);
          return of({ success: false, message: error.message, data: [] });
        })
      );
  }
}
